import Head from "next/head";

import "../globals.scss";
import "../variables.scss";
import '../components/Content/Content.scss'
import '../components/Header/Header.scss'
import '../components/Sidebar/Sidebar.scss'
import '../components/Content/Content.scss'
import Header from "../components/Header/Header";
import {ThemeContextProvider} from "../contexts/useTheme";
import Sidebar from "../components/Sidebar/Sidebar";
import {useEffect, useState} from "react";
import {modular} from "../util/constants";
import Image from 'next/image'


export default function App({Component, pageProps}) {

    const [showSidebar, setShowSidebar] = useState(false)

    useEffect(() => {
        document.documentElement.style.setProperty('--main-color', modular.mainColor);
        if (modular.headerButton) {
            document.documentElement.style.setProperty('--header-button-color', modular.headerButton.color);
            document.documentElement.style.setProperty('--header-button-color-hover', modular.headerButton.hoverColor);
        }
    }, []);

    return (
        <>
            <Head>
                <link rel="shortcut icon" href={"./favicon.ico"}/>
                <title>{modular.title}</title>
            </Head>
            <ThemeContextProvider>
                <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar}/>
                <Sidebar show={showSidebar}/>
                <div onClick={() => {
                    setShowSidebar(false)
                }}>
                    <Component {...pageProps} />
                </div>
                <div className={'bg'}>
                    <Image src={modular.background}
                           layout="fill"
                           objectFit="cover"
                           objectPosition="center center"
                           priority={true}
                    />
                </div>
            </ThemeContextProvider>
        </>
    );
}
